import React, { useState, useEffect } from 'react'
import { Col, Container, Form, FormGroup, Input, Label, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import CommonLogo from '../Common/CommonLogo';
import { Btn, H2, H4, P } from '../../../../../AbstractElements';
import { CreateYourPassword, Done, EnterOtp, NewPassword, RetypePassword, SignIn } from '../../../../../Utils/Constants';
import { toast } from 'react-toastify';
import axios from 'axios';
import { backendbaseUrl } from '../../../../../Utils/baseUrl';
import { useNavigate } from "react-router-dom";
export default function ForgetPassword() {
    const [isPasswordVisible, setPasswordVisible] = useState(false);
    const toggle = () => setPasswordVisible(!isPasswordVisible);
    const [email, SetEmail] = useState("")
    const [error, setError] = useState('');

    const [isDisabled, setIsDisabled] = useState(false); // To manage button disabling
    const [timer, setTimer] = useState(60);

    const [buttonName, setbuttonName] = useState('Send');
    const navigate = useNavigate();

    const handleSubmitEmailSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        if (!validateEmail(email)) {
            toast.error("please enter a valid email")
        }
        else {



            try {
                const response = await axios.get(
                    `${backendbaseUrl}/users/reset-password/?email=${email}`,
                );
                if (response.status === 200) {
                    toast.success("Otp sent successfully ")
                    setIsDisabled(true);
                    setTimer(60);
                    setbuttonName('Resend Otp')
                    console.log(response.data)
                    localStorage.setItem("plink", response.data.data.reset_link)
                }
            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 400) {
                        toast.error("We couldn't find your email, please Verify your Email !");
                    } else {
                        toast.error(
                            error.response.data.message || "An unknown error occurred"
                        );
                    }
                } else {
                    toast.error("Network error or server is down");
                }
            }
        }




    }

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const value = e.target.value;
        SetEmail(value)
        if (!validateEmail(value)) {
            setError('Please enter a valid email address');
        } else {
            setError('');
        }
    };

    useEffect(() => {
        let interval: NodeJS.Timeout;
        if (isDisabled && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        }

        if (timer === 0) {
            setIsDisabled(false); // Re-enable the button after 60 seconds
            setTimer(60); // Reset the timer
        }

        return () => clearInterval(interval); // Clean up the interval on component unmount
    }, [isDisabled, timer]);




    const validateEmail = (email: string) => {
        const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return regex.test(email);
    };




    // const handlePasswordChangeubmit = async (e: React.FormEvent<HTMLFormElement>) => {

    //     e.preventDefault();

    // }


    const [formData, setFormData] = useState({ otp: "", password: "", password1: "" });
    const [errors, setErrors] = useState({ otp: "", password: "", password1: "" });
    const handlePasswordRestChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
        setErrors({ ...errors, [e.target.name]: "" })
    };


    const PasswordResethandleSubmit = async (e: any) => {
        e.preventDefault();

        let PasswordResetformIsValid = true;
        let newErrors = { otp: "", password: "", password1: "" };

        if (formData.otp.length !== 6) {
            PasswordResetformIsValid = false;
            newErrors.otp = "otp must be atleast 6 digitis"
        }

        console.log(formData.password.length)
        if (formData.password.length! < 6) {
            PasswordResetformIsValid = false;
            newErrors.password = "password must atleast have 6 character"
        }
        else {
            newErrors.password = ""
        }

        if (formData.password1 !== formData.password) {
            PasswordResetformIsValid = false;
            newErrors.password1 = "two password are not matching"
        }


        if (PasswordResetformIsValid) {

            const resetLink = localStorage.getItem("plink")
            if (!resetLink) {
                PasswordResetformIsValid = false;
                toast.error("Please submit your email . ")
            }

            try {
                const response = await axios.post(
                    `${backendbaseUrl}/users/reset-password-verification/${resetLink}/`,
                    formData
                );
                if (response.status === 200) {
                    toast.success("password rest success")
                    setTimeout(() => {
                        navigate("/login"); // Redirect to login page
                    }, 3000);
                }
            } catch (error: any) {
                if (error.response) {
                    if (error.response.status === 400) {
                        toast.error(error.response.data.message);
                    }

                    else if (error.response.status === 406) {
                        toast.error("Please submit your email to get OTP");
                    }

                    else {
                        toast.error(
                            error.response.data.message || "An unknown error occurred"
                        );
                    }
                } else {
                    toast.error("Network error or server is down");
                }
            }

        }
        else {
            setErrors(newErrors)
        }


    };


    return (
        <div className="page-wrapper">
            <Container fluid className="p-0">
                <Row>
                    <Col xs={12}>
                        <div className="login-card login-dark">
                            <div>
                                <div><CommonLogo /></div>
                                <div className="login-main">
                                    <Form className="theme-form" onSubmit={handleSubmitEmailSubmit}>
                                        <H2>Reset Your Password</H2>
                                        <FormGroup>
                                            <Col><Label>Enter your registerd Email</Label></Col>
                                            <Row>
                                                <Col xs={8} sm={12}><Input className="mb-1" id='email' type="email" value={email} onChange={handleChange} placeholder="example@yourmail.com" /></Col>
                                                {error && <div className="text-danger mt-2">{error}</div>} {/* Error message shown under input */}
                                                <Col xs={12}>
                                                    <div className="text-end">
                                                        <Btn color='primary' block className="m-t-10" disabled={isDisabled}>{isDisabled ? `${timer} seconds` : buttonName} {/* Display timer while disabled */}</Btn>

                                                    </div>
                                                </Col>
                                            </Row>
                                        </FormGroup>
                                    </Form>
                                    <Form className="theme-form" onSubmit={PasswordResethandleSubmit}>
                                        {/* OTP Field */}
                                        <FormGroup>
                                            <Col>
                                                <Label className="pt-0">{EnterOtp}</Label>
                                            </Col>
                                            <Row>
                                                <Col>
                                                    <Input
                                                        className="text-center opt-text"
                                                        type="text"
                                                        maxLength={6}
                                                        name="otp"
                                                        value={formData.otp}
                                                        onChange={handlePasswordRestChange}
                                                        placeholder={!isDisabled ? " " : "Enter Otp "}
                                                    />
                                                    {errors.otp && <p style={{ color: "red" }}>{errors.otp}</p>}
                                                </Col>
                                            </Row>
                                        </FormGroup>

                                        {/* Create Password Section */}
                                        <H4 className="mt-4">{CreateYourPassword}</H4>

                                        {/* New Password Field */}
                                        <FormGroup>
                                            <Col><Label>{NewPassword}</Label></Col>
                                            <div className="form-input position-relative">
                                                <Input
                                                    type={isPasswordVisible ? 'text' : 'password'}
                                                    placeholder="*********"
                                                    name="password"
                                                    value={formData.password}
                                                    onChange={handlePasswordRestChange}
                                                />
                                                {errors.password && <p style={{ color: "red" }}>{errors.password}</p>}

                                                <div className='show-hide' onClick={toggle}>
                                                    <span className={!isPasswordVisible ? 'show' : ''}></span>
                                                </div>
                                            </div>
                                        </FormGroup>

                                        {/* Re-type Password Field */}
                                        <FormGroup>
                                            <Col><Label>{RetypePassword}</Label></Col>
                                            <Input
                                                type={isPasswordVisible ? 'text' : 'password'}
                                                placeholder="*********"
                                                name="password1"
                                                value={formData.password1}
                                                onChange={handlePasswordRestChange}
                                            />
                                            {errors.password1 && <p style={{ color: "red" }}>{errors.password1}</p>}

                                            <div className='show-hide' onClick={toggle}></div>
                                        </FormGroup>

                                        {/* Checkbox */}
                                        <FormGroup className="mb-0">

                                            <Btn color="primary" type="submit" className="w-100">{Done}</Btn>
                                        </FormGroup>

                                        {/* Sign-In Link */}
                                        <P className="mt-4 mb-0 text-center">
                                            {"Already have an account?"}
                                            <Link to={`${process.env.PUBLIC_URL}/auth/login`} className="ms-2">{SignIn}</Link>
                                        </P>
                                    </Form>
                                </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    )
}
